module.exports = __webpack_public_path__ + "static/img/index.35631df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/vibrate/941B/index.png
// module id = IQHx
// module chunks = 0